import { Component, OnInit } from '@angular/core';
import { ClaimRow } from '../../../../../models/api/view/claim-view/claim-row';
import { GeneralLiabilityResponse } from '../../../../../models/api/view/claim/details/general-liability/general-liability-response';
import { BaseComponent } from '../../../../base/base.component';
import { PageHeaderComponent } from '../../../../core/labels/page-header.component';
import { TabPanelComponent } from '../../../../core/panels/tab-panel/tab-panel.component';
import { TabComponent } from '../../../../core/panels/tab-panel/tab.component';
import { CasualtyComponent } from '../casualty/casualty.component';
import { AllocationsGlComponent } from './allocations-gl.component';
import { IbcGlComponent } from './ibc-gl.component';
import { LiabilityTypeGlComponent } from './liabillity-type-gl.component';
import { OccurenceGlComponent } from './occurence-gl.component';
import { ProfessionalLiabilityComponent } from './professional-liability.component';
import { PropertyGlComponent } from './property-gl.component';

@Component({
  selector: 'app-general-liability',
  imports: [
    PageHeaderComponent,
    TabPanelComponent,
    TabComponent,
    CasualtyComponent,
    OccurenceGlComponent,
    LiabilityTypeGlComponent,
    PropertyGlComponent,
    IbcGlComponent,
    ProfessionalLiabilityComponent,
    AllocationsGlComponent,
  ],
  template: `
    <app-page-header label="General liability" />
    <app-tab-panel>
      <app-tab label="Event">
        <ng-template #content> <app-casualty /> </ng-template>
      </app-tab>
      @if (detailAuth) {
        <app-tab label="Occurrence">
          <ng-template #content>
            <app-occurence-gl [dataSource]="dataSource" />
          </ng-template>
        </app-tab>
        <app-tab label="Liability type">
          <ng-template #content>
            <app-liability-type-gl [dataSource]="dataSource" />
          </ng-template>
        </app-tab>
        <app-tab label="Property">
          <ng-template #content>
            <app-property-gl [dataSource]="dataSource" />
          </ng-template>
        </app-tab>
      }
      @if (detailAuth && showProfessionalLiability) {
        <app-tab label="Professional Liability">
          <ng-template #content>
            <app-professional-liability
              [dataSource]="dataSource"
              [showMMFields]="showMMFields"
            />
          </ng-template>
        </app-tab>
      }
      @if (detailAuth && showAllocations) {
        <app-tab label="Allocations">
          <ng-template #content> <app-allocations-gl /> </ng-template>
        </app-tab>
      }
      @if (detailAuth && showIbc) {
        <app-tab label="IBC">
          <ng-template #content> <app-ibc-gl /> </ng-template>
        </app-tab>
      }
    </app-tab-panel>
  `,
  styles: ``,
})
export class GeneralLiabilityComponent extends BaseComponent implements OnInit {
  claimRow: ClaimRow;
  dataSource: GeneralLiabilityResponse;
  detailAuth = false;
  showProfessionalLiability = false;
  showAllocations = false;
  showIbc = false;
  showMMFields = false;

  async ngOnInit(): Promise<void> {
    this.detailAuth = this.session.authorize('Details');
    this.claimRow = this.view.currentClaim();

    // Tab visibility based on line code
    const lineCode = this.claimRow.line;
    this.showProfessionalLiability = ['MM', 'PF'].includes(lineCode);
    this.showAllocations = ['MM', 'PF'].includes(lineCode);
    this.showMMFields = lineCode === 'MM';

    await this.loadData();
    this.view.hideLoading();
  }

  private async loadData(): Promise<void> {
    this.dataSource = await this.api.generalLiability.get({
      recordSource: this.claimRow.recordSource,
      recordId: this.claimRow.recordId,
    });
    this.showIbc = this.dataSource.isCanadianJurisdiction ?? false;
  }
}
